import { render, staticRenderFns } from "./AddRecipients.vue?vue&type=template&id=096c88df&scoped=true&"
import script from "./AddRecipients.vue?vue&type=script&lang=js&"
export * from "./AddRecipients.vue?vue&type=script&lang=js&"
import style0 from "./AddRecipients.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddRecipients.vue?vue&type=style&index=1&id=096c88df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096c88df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('096c88df')) {
      api.createRecord('096c88df', component.options)
    } else {
      api.reload('096c88df', component.options)
    }
    module.hot.accept("./AddRecipients.vue?vue&type=template&id=096c88df&scoped=true&", function () {
      api.rerender('096c88df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/eCircular/AddRecipients.vue"
export default component.exports